import { dataSource, domain_vizr, PYTHON_VIZ_IP_ADDRESS } from "../../redux/constants/constants";

export const fetchTotalDataTagFilesAPI = `${domain_vizr}/tenant/dataTag/totalFiles`;
export const fetchDataTagDashboardTotalCountAPI = `${domain_vizr}/tenant/dataTag/totalFiles`;
export const fetchDataEstateAPI = `${domain_vizr}/tenant/dataTag/dataEstate/summary`;
export const fetchDataTagFileClassificationsAPI = `${domain_vizr}/tenant/dataTag/FileClassifications`;
export const fetchDataTagSensitiveAndRegulatedDataAPI = `${domain_vizr}/tenant/dataTag/sensitiveAndRegulatedData`;
export const fetchDataTagDuplicateFileDataAPI = `${domain_vizr}/tenant/dataTag/duplicateFileData`;
export const fetchDataTagMetadataAPI = `${domain_vizr}/tenant/dataTag/metadata/completeness`;
export const fetchDataTagDataAccessibilityAPI = `${domain_vizr}/tenant/dataTag/getFileInsights`;
export const SET_TOTAL_DATA_TAG_FILES = "FETCH_TOTAL_DATA_TAG_FILES";
export const SET_DATA_TAG_LOADING = "SET_DATA_TAG_LOADING";
export const FETCH_DATA_TAG_DASHBOARD_DATA = "FETCH_DATA_TAG_DASHBOARD_DATA";
export const SET_DATA_ESTATE = "SET_DATA_ESTATE";
export const SET_DATA_TAG_FILE_CLASSIFICATIONS =
  "SET_DATA_TAG_FILE_CLASSIFICATIONS";
export const SET_DATA_TAG_SENSITIVE_AND_REGULATED_DATA =
  "SET_DATA_TAG_SENSITIVE_AND_REGULATED_DATA";
export const SET_DATA_TAG_DUPLICATE_FILE_DATA =
  "SET_DATA_TAG_DUPLICATE_FILE_DATA";
export const SET_DATA_TAG_METADATA = "SET_DATA_TAG_METADATA";
export const SET_DATA_TAG_ACCESSIBILITY = "SET_DATA_TAG_ACCESSIBILITY";
export const RESET_DATA_TAG_STATE = "RESET_DATA_TAG_STATE";
export const SET_DATA_TAG_NODES_DATA = "SET_DATA_TAG_NODES_DATA";
export const FETCH_DATA_TAG_ALL_FILES = "FETCH_DATA_TAG_ALL_FILES";
export const SET_DATA_TAG_ALL_FILES = "SET_DATA_TAG_ALL_FILES";
export const SET_SELECTED_DATA_TAG_SOURCE_ID =
  "SET_SELECTED_DATA_TAG_SOURCE_ID";
export const fetchDataTagAllFilesAPI = (dataSourceId) => {
  return `${domain_vizr}/tenant/dataTag/files?dataSourceId=${dataSourceId}`;
};
export const FETCH_ALL_DATA_SOURCES_API_DATA_TAG =
  "FETCH_ALL_DATA_SOURCES_API_DATA_TAG";
export const SET_ALL_DATA_TAG_SOURCES = "SET_ALL_DATA_TAG_SOURCES";
// Centralized color mapping for classification types
export const CLASSIFICATION_COLORS = {
  MARKETING: "#FF8A65",
  FINANCIAL: "#AA46BE",
  PERSONAL: "#2B43FF",
  ORGANIZATIONAL: "#00C49F",
  API: "#42A5F5",
  MEDICAL: "#EF5350",
  NO_SENSITIVITY: "#FFBB28",
  OTHER: "#8D8D8D",
  NOT_PROCESSED: "#7E57C2",
};

export const FETCH_DATA_TAG_USERS = "FETCH_DATA_TAG_USERS";
export const SET_DATA_TAG_USERS = "SET_DATA_TAG_USERS";
export const fetchDataTagUsersAPI = (dataSourceId) => {
  return `${domain_vizr}/tenant/dataTag/usersByFileCount?dataSourceId=${dataSourceId}`;
};
export const fetchDataEstateSummaryAPI = (dataSourceId) => {
  return `${domain_vizr}/tenant/dataTag/${dataSourceId}/summary`;
};
export const FETCH_DATA_ESTATE_SUMMARY = "FETCH_DATA_ESTATE_SUMMARY";
export const SET_DATA_ESTATE_SUMMARY = "SET_DATA_ESTATE_SUMMARY";
export const fetchDataTagDrivesAPI = (dataSourceId) => {
  return `${domain_vizr}/tenant/dataTag/driveSummary?dataSourceId=${dataSourceId}`;
};
export const FETCH_DATA_TAG_DRIVES = "FETCH_DATA_TAG_DRIVES";
export const SET_DATA_TAG_DRIVES = "SET_DATA_TAG_DRIVES";
export const FETCH_DATA_TAG_FILES = "FETCH_DATA_TAG_FILES";
export const SEARCH_DATA_TAG_FILES = `${domain_vizr}/tenant/dataTag/files/search`;
export const SET_SEARCHED_DATA_TAG_FILES = "SET_SEARCHED_DATA_TAG_FILES";
export const FETCH_DATA_TAG_USERS_LIST = "FETCH_DATA_TAG_USERS_LIST";
export const SET_SEARCHED_DATA_TAG_USERS = "SET_SEARCHED_DATA_TAG_USERS";

export const FETCH_SIZE_CARD_DATA = "FETCH_SIZE_CARD_DATA";
export const SET_SIZE_CARD_DATA = "SET_SIZE_CARD_DATA";

export const FETCH_SENSITIVE_SUMMARY_CARD_DATA =
  "FETCH_SENSITIVE_SUMMARY_CARD_DATA";
export const SET_SENSITIVE_SUMMARY_CARD_DATA =
  "SET_SENSITIVE_SUMMARY_CARD_DATA";

export const FETCH_CATEGORY_CARD_DATA = "FETCH_CATEGORY_CARD_DATA";
export const SET_CATEGORY_CARD_DATA = "SET_CATEGORY_CARD_DATA";

export const DATA_ESTATE_SUMMARY_LOADER = "DATA_ESTATE_SUMMARY_LOADER";

export function formatCount(num) {
  if (num >= 1_000_000_000_000) {
    // Trillions
    return Math.floor(num / 100_000_000_000) / 10 + "T";
  }
  if (num >= 1_000_000_000) {
    // Billions
    return Math.floor(num / 100_000_000) / 10 + "B";
  }
  if (num >= 1_000_000) {
    // Millions
    return Math.floor(num / 100_000) / 10 + "M";
  }
  if (num >= 1_000) {
    // Thousands
    return Math.floor(num / 100) / 10 + "K";
  }
  return num;
}

export const formatEpoch = (epoch) => {
  if (!epoch) return null;

  const d = new Date(Number(epoch));

  const MM = String(d.getMonth() + 1).padStart(2, "0");
  const DD = String(d.getDate()).padStart(2, "0");
  const YYYY = d.getFullYear();
  const HH = String(d.getHours()).padStart(2, "0");
  const mm = String(d.getMinutes()).padStart(2, "0");

  return `${MM}-${DD}-${YYYY} ${HH}:${mm}`;
};

export const POP_UP_LOCATION_KEY = "POP_UP_LOCATION_KEY";

export const fetchAllFileTypes = (dataSourceId) => {
  return `${domain_vizr}/tenant/dataTag/fileTypes?dataSourceId=${dataSourceId}`;
};
export const FETCH_ALL_FILE_TYPES_DATA = "FETCH_ALL_FILE_TYPES_DATA";
export const SET_ALL_FILE_TYPE_LIST = "SET_ALL_FILE_TYPE_LIST";
export const DETAILS_PAGE_LOADER = "DETAILS_PAGE_LOADER";


// Data Tag Reports
export const FETCH_DATA_TAG_REPORTS = "FETCH_DATA_TAG_REPORTS";
export const DOWNLOAD_DATA_TAG_REPORT = "DOWNLOAD_DATA_TAG_REPORT";
export const VIEW_DATA_TAG_REPORT = "VIEW_DATA_TAG_REPORT";
export const SET_DATA_TAG_REPORTS = "SET_DATA_TAG_REPORTS";
export const SET_DATA_TAG_ALL_REPORTS = "SET_DATA_TAG_ALL_REPORTS";
export const SET_DATA_TAG_REPORTS_LOADER = "SET_DATA_TAG_REPORTS_LOADER";
export const SET_DATA_TAG_DOWNLOAD_LOADER = "SET_DATA_TAG_DOWNLOAD_LOADER";
export const SET_DATA_TAG_SNACKBAR = "SET_DATA_TAG_SNACKBAR";
export const CLEAR_DATA_TAG_SNACKBAR = "CLEAR_DATA_TAG_SNACKBAR";
export const UPLOAD_DATA_TAG_REPORT = "UPLOAD_DATA_TAG_REPORT";
export const UPLOAD_DATA_TAG_REPORT_SUCCESS = "UPLOAD_DATA_TAG_REPORT_SUCCESS";
export const UPLOAD_DATA_TAG_REPORT_FAILURE = "UPLOAD_DATA_TAG_REPORT_FAILURE";
export const SET_UPLOAD_PROGRESS = "SET_UPLOAD_PROGRESS";
export const CLEAR_UPLOAD_STATE = "CLEAR_UPLOAD_STATE";
export const DATA_TAG_REPORTS_BASE_URL = PYTHON_VIZ_IP_ADDRESS;
export const DATA_TAG_REPORTS_API_URL = `${PYTHON_VIZ_IP_ADDRESS}/s3_files`;
export const DATA_TAG_UPLOAD_API_URL = `${PYTHON_VIZ_IP_ADDRESS}/s3_upload`;

export const DATA_TAG_DUPLICATE_DRIVE_DATA = "DATA_TAG_DUPLICATE_DRIVE_DATA";
export const SET_DATA_TAG_POPUP_LOADER = "SET_DATA_TAG_POPUP_LOADER";
export const SET_DATA_TAG_DUPLICATE_DRIVE_DATA = "SET_DATA_TAG_DUPLICATE_DRIVE_DATA";
export const fetchDataTagDuplicateDriveDataAPI = (dataSourceId, currentPage, pageSize) => {
  return `${domain_vizr}/tenant/dataTag/duplicate-summary?dataSourceId=${dataSourceId}&page=${currentPage}&size=${pageSize}`;
}

export const DATA_TAG_DUPLICATE_USER_DATA = "DATA_TAG_DUPLICATE_USER_DATA";
export const fetchDataTagDuplicateUserDataAPI = (dataSourceId, actorId, currentPage, pageSize) => {
  return `${domain_vizr}/tenant/dataTag/actors/${actorId}/duplicate-directories?dataSourceId=${dataSourceId}&page=${currentPage}&size=${pageSize}`;
}
export const SET_DATA_TAG_DUPLICATE_USER_DATA = "SET_DATA_TAG_DUPLICATE_USER_DATA";

export const DATA_TAG_DUPLICATE_USER_DATA_2 = "DATA_TAG_DUPLICATE_USER_DATA_2";
export const fetchDataTagDuplicateUserDataAPI_2 = (dataSourceId, actorId, duplicateActorId, directory, currentPage, pageSize) => {
  return `${domain_vizr}/tenant/dataTag/actors/${actorId}/duplicates/files?dataSourceId=${dataSourceId}&page=${currentPage}&size=${pageSize}&duplicateActorId=${duplicateActorId}`;
}
export const SET_DATA_TAG_DUPLICATE_USER_DATA_2 = "SET_DATA_TAG_DUPLICATE_USER_DATA_2";

export const DATA_TAG_DUPLICATE_FILE_DATA = "DATA_TAG_DUPLICATE_FILE_DATA";
export const SET_DATA_TAG_DUPLICATE_DRIVE_FILE_DATA = "SET_DATA_TAG_DUPLICATE__DRIVE_FILE_DATA";
export const fetchDataTagDuplicateDriveFileDataAPI = (dataSourceId, actorId, currentPage, pageSize) => {
  return `${domain_vizr}/tenant/dataTag/actors/${actorId}/duplicate-files?dataSourceId=${dataSourceId}&page=${currentPage}&size=${pageSize}`;
}
export const DATA_TAG_DUPLICATE_FILE_DATA_2 = "DATA_TAG_DUPLICATE_FILE_DATA_2";
export const SET_DATA_TAG_DUPLICATE_DRIVE_FILE_DATA_2 = "SET_DATA_TAG_DUPLICATE__DRIVE_FILE_DATA_2";
export const fetchDataTagDuplicateDriveFileDataAPI_2 = (dataSourceId, fileId, currentPage, pageSize) => {
  return `${domain_vizr}/tenant/dataTag/files/${fileId}/duplicates?dataSourceId=${dataSourceId}&page=${currentPage}&size=${pageSize}`;
}
export const REGULATED_COLOR_PALETTE = [
  "#1f77b4",
  "#ff7f0e",
  "#2ca02c",
  "#d62728",
  "#9467bd",
  "#8c564b",
  "#e377c2",
  "#7f7f7f",
  "#bcbd22",
  "#17becf",
  "#393b79",
  "#637939",
  "#8c6d31",
  "#843c39",
  "#7b4173",
  "#3182bd",
  "#31a354",
  "#756bb1",
  "#636363",
  "#e6550d",
];

export const GET_FILE_MAP_DATA = "GET_FILE_MAP_DATA";
export const SET_FILE_MAP_DATA = "SET_FILE_MAP_DATA";

export const fileMapUrl = (actorId, dataSourceId) => {
  return `${domain_vizr}/tenant/dataTag/actors/${actorId}/duplicate-sensitivity-summary?dataSourceId=${dataSourceId}`
}

export const FETCH_USERS_LIST = "FETCH_USERS_LIST";
export const SET_USERS_LIST = "SET_USERS_LIST";
export const userFilterList = ( dataSourceId, actorId) => {
  return `${domain_vizr}/tenant/dataTag/actors/${actorId}/duplicate-actors?dataSourceId=${dataSourceId}`
}


export const FETCH_FILES_LIST = "FETCH_FILES_LIST";
export const SET_FILES_LIST = "ET_FILES_LIST";
export const fileFilterList = (dataSourceId, actorId) => {
  return `${domain_vizr}/tenant/dataTag/actors/${actorId}/duplicate-file-names?dataSourceId=${dataSourceId}`
}
export const fetchDataSourcesDataTag = () => {
  return `${domain_vizr}/tenant/datasource/list/datatag`
}
export const FETCH_DATA_SOURCES_DATA_TAG = "FETCH_DATA_SOURCES_DATA_TAG";
export const SET_DATA_SOURCES_DATA_TAG = "SET_DATA_SOURCES_DATA_TAG";
export const SET_IS_DATABASE = "SET_IS_DATABASE";

//Data Estate Summary Tab
export const FETCH_DATA_ESTATE_SUMMARY_TAB = "FETCH_DATA_ESTATE_SUMMARY_TAB";
export const SET_DATA_ESTATE_SUMMARY_TAB = "SET_DATA_ESTATE_SUMMARY_TAB";
export const fetchDataEstateSummaryTabAPI = () => {
  return `${domain_vizr}/tenant/dataTag/regenerate/dataEstateSummary`;
}
export const DATA_ESTATE_SUMMARY_TAB_LOADER = "DATA_ESTATE_SUMMARY_TAB_LOADER";